import { render, staticRenderFns } from "./TextNotesRow.vue?vue&type=template&id=d745227c&"
import script from "./TextNotesRow.vue?vue&type=script&lang=js&"
export * from "./TextNotesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports